function mapBoundaryUrl(communityName) {
  return `https://ingenuity-artlook.s3.us-east-2.amazonaws.com/communityConfigs/${communityName}/boundaries.json`
}

export default mapBoundaryUrl
